module.exports = __webpack_public_path__ + "img/chicken-mygallinas-icon.e648e747.svg";